import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white expected-earnings-box" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" };
const _hoisted_3 = { class: "fw-black mb-12 lh-1" };
const _hoisted_4 = { class: "text-muted fw-medium d-flex align-items-center gap-2" };
const _hoisted_5 = { class: "text-black fw-bold ms-1" };
const _hoisted_6 = {
    id: "expectedEraningsChart",
    class: "chart"
};
const _hoisted_7 = { class: "col-md-6" };
const _hoisted_8 = { class: "form-group position-relative transition mt-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_apexchart = _resolveComponent("apexchart");
    const _component_v_select = _resolveComponent("v-select");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "d-block mb-6 fs-13 text-uppercase fs-13 text-uppercase text-dark-emphasis fw-bold" }, " TOP PRODUITS ", -1)),
            _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.amountTotal) + " CHF", 1),
            _createElementVNode("table", null, [
                _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topSellResponse, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_4, [
                                _createElementVNode("span", {
                                    class: "rounded-circle d-inline-block",
                                    style: _normalizeStyle({
                                        width: '10px',
                                        height: '10px',
                                        backgroundColor: _ctx.expectedEraningsChart.colors[index]
                                    })
                                }, null, 4),
                                _createTextVNode(" " + _toDisplayString(item.name) + " - ", 1),
                                _createElementVNode("span", _hoisted_5, _toDisplayString(Number(item.total_sales).toFixed(2)) + " CHF", 1)
                            ])
                        ]));
                    }), 128))
                ])
            ]),
            _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_apexchart, {
                    type: "donut",
                    height: "150",
                    options: _ctx.expectedEraningsChart,
                    series: _ctx.expected
                }, null, 8, ["options", "series"])
            ]),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_v_select, {
                        modelValue: _ctx.categorieSelected,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.categorieSelected) = $event)),
                        options: _ctx.originalCategories,
                        label: "name",
                        reduce: categorie => categorie.id,
                        placeholder: "Categorie"
                    }, null, 8, ["modelValue", "options", "reduce"])
                ])
            ])
        ])
    ]));
}
